export default __webpack_public_path__ + "static/SRUS CS30 - Especification Del Producto y Datos Técnicos-697f2ff8d178fd9781a11bc371ff253d.pdf";